import {
  FormErrorWithDiscriminatedField,
  FormSchema,
  StationMeansOfPaymentEnum,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/formSchema";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Field,
  FieldErrorText,
  Radio,
  RadioGroup,
} from "shared/components/Spor";

type StationSalesChannelReducedProps = {};

export const StationSalesChannelReduced: FC<
  StationSalesChannelReducedProps
> = () => {
  const { t } = useTranslation();
  const formMethods = useFormContext<FormSchema>();
  const meansOfPayment = formMethods.watch("stationForm.meansOfPayment");
  const fieldErrors: FormErrorWithDiscriminatedField<"meansOfPayment"> =
    formMethods.formState.errors.stationForm;

  return (
    <Field as="fieldset" invalid={!!fieldErrors?.meansOfPayment}>
      <Field as="legend">{t("Manglende betalingsvalg")}</Field>

      <RadioGroup
        name="meansOfPayment"
        value={meansOfPayment}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const value = e.target.value as StationMeansOfPaymentEnum;
          formMethods.setValue("stationForm.meansOfPayment", value);
          formMethods.clearErrors("stationForm.meansOfPayment");
        }}
      >
        <Radio value="COINS">{t("Mynt")}</Radio>
        <Radio value="BANKNOTE">{t("Seddel")}</Radio>
        <Radio value="CARD">{t("Kort")}</Radio>
      </RadioGroup>

      <FieldErrorText marginTop="12px">
        {fieldErrors?.meansOfPayment?.message}
      </FieldErrorText>
    </Field>
  );
};
